import { ItemListCollapsibleSectionHeaderRowData } from "@/components/item-list/types";
import {
  MDSTextColor,
  MDSTextVariant,
  MDSTextWeight,
  MDSIcon,
  MDSIconColor,
  MDSIconKind,
} from "@/mds";
import {
  StyledWrapper,
  StyledPrimaryText,
  StyledRightAddonContainer,
  StyledTitleWrapper,
} from "./item-list-collapsible-section-header-row.style";

interface Props {
  data: ItemListCollapsibleSectionHeaderRowData;
}

export const ItemListCollapsibleSectionHeaderRow = ({ data }: Props) => {
  const { title, rightAddon, isCollapsed, onCollapseChange } = data.payload;

  const handleClick = () => {
    onCollapseChange(!isCollapsed);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <StyledWrapper
      key={title}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-expanded={!isCollapsed}
    >
      <StyledTitleWrapper>
        <MDSIcon
          kind={isCollapsed ? MDSIconKind.CaretRight : MDSIconKind.CaretDown}
          color={MDSIconColor.Secondary}
          size={11}
        />
        <StyledPrimaryText
          color={MDSTextColor.Secondary}
          variant={MDSTextVariant.TextXs}
          weight={MDSTextWeight.SemiBold}
        >
          {title}
        </StyledPrimaryText>
      </StyledTitleWrapper>
      {rightAddon && <StyledRightAddonContainer>{rightAddon}</StyledRightAddonContainer>}
    </StyledWrapper>
  );
};
